import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  statistic: generateApiPath({ prefix: AuthLevel.AUTH, name: 'statistic' }),
}

export { paths }
